import Vue from 'vue'

// 401(token 过期/被踢) → 跳 keycloak 登录页。
// keycloak 访问方式与 account.js 一致：Vue.prototype.$keycloak.keycloak（嵌套）。
// isRedirecting 兜并发：多个请求同时 401 只跳一次。
let isRedirecting = false

export default function handleUnauthorized() {
  if (isRedirecting) return
  const kc = Vue.prototype.$keycloak
  // keycloak 未就绪时不跳、不报错。
  if (kc && kc.keycloak && typeof kc.keycloak.login === 'function') {
    isRedirecting = true
    kc.keycloak.login()
  }
}
